import { render, staticRenderFns } from "./GroupTree.vue?vue&type=template&id=2a723cbb"
import script from "./GroupTree.vue?vue&type=script&lang=ts"
export * from "./GroupTree.vue?vue&type=script&lang=ts"
import style0 from "./GroupTree.vue?vue&type=style&index=0&id=2a723cbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports